import SelectLanguage from './change-language';

export default SelectLanguage;
